import { bigIntClamp, bigIntMultiply } from "./bigint.js";
import { isBigNumberish } from "./index.js";
export function isValidRequest(request) {
    return (!!request.callGasLimit &&
        !!request.maxFeePerGas &&
        request.maxPriorityFeePerGas != null &&
        !!request.preVerificationGas &&
        !!request.verificationGasLimit);
}
export function applyUserOpOverride(value, override) {
    if (override == null) {
        return value;
    }
    if (isBigNumberish(override)) {
        return override;
    }
    else {
        return value != null ? bigIntMultiply(value, override.multiplier) : value;
    }
}
export function applyUserOpFeeOption(value, feeOption) {
    if (feeOption == null) {
        return value ?? 0n;
    }
    return value != null
        ? bigIntClamp(feeOption.multiplier
            ? bigIntMultiply(value, feeOption.multiplier)
            : value, feeOption.min, feeOption.max)
        : feeOption.min ?? 0n;
}
export function applyUserOpOverrideOrFeeOption(value, override, feeOption) {
    return value != null && override != null
        ? applyUserOpOverride(value, override)
        : applyUserOpFeeOption(value, feeOption);
}
//# sourceMappingURL=userop.js.map